var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "w-100 section-display" },
    [
      _c(
        "div",
        {
          staticClass: "container-fluid fixed-top w-100 px-0",
          attrs: { id: "nav-info", role: "navigation" }
        },
        [_c("section-navigation", { attrs: { pageData: _vm.pageData } })],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "section-form",
          class: {
            "quote-panel-open": _vm.quotePanelStatus,
            "quote-panel-close": !_vm.quotePanelStatus,
            bundle: _vm.flowType === "bundle"
          },
          attrs: { role: "main" }
        },
        [
          _c("form-info", {
            attrs: {
              pageData: _vm.pageData,
              formLocation: _vm.formPrependLocation
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "row no-gutters mx-0" }, [
            _c("div", { staticClass: "col-12" }, [
              _c(
                "form",
                {
                  staticClass: "needs-validation",
                  on: {
                    keydown: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      $event.preventDefault()
                      return _vm.submitted($event)
                    }
                  }
                },
                [
                  _vm._l(_vm.createTree, function(group, i) {
                    return group
                      ? _c(
                          "div",
                          { key: i },
                          [
                            _c("section-layout", {
                              attrs: {
                                group: group,
                                i: i,
                                pageData: _vm.pageData
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  }),
                  _vm._v(" "),
                  _c("hr", { staticClass: "mx-2" }),
                  _vm._v(" "),
                  _c("form-info", {
                    attrs: {
                      pageData: _vm.pageData,
                      formLocation: _vm.formAppendLocation
                    }
                  }),
                  _vm._v(" "),
                  _vm.pageData &&
                  _vm.pageData.continue_buttons &&
                  _vm.continueEnabled
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "form-row justify-content-center mx-0 my-3"
                        },
                        [
                          _c("div", { staticClass: "col-8 text-center" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-primary btn",
                                attrs: { type: "submit" },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.submitted($event)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.submitButtonLabel))]
                            )
                          ])
                        ]
                      )
                    : _vm._e()
                ],
                2
              )
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _vm.isPolicyBound()
        ? _c("form-alerts", {
            class: {
              "policy-bound-alert": true,
              "margin-25": _vm.quotePanelStatus
            },
            attrs: { pageData: _vm.policyBoundAlert }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6922a095", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6922a095","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/interview/propertyInsurance/SectionDisplay.vue
// module id = null
// module chunks = 